import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoTroncal } from '../_models/producto-troncal';

@Injectable({
  providedIn: 'root'
})
export class ProductoTroncalService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosTroncal';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoTroncal[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoTroncal[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoTroncal ) );
  }

  crear( regCrear: ProductoTroncal ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoTroncal ) );
  }

  actualizar( regActualizar: ProductoTroncal ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as ProductoTroncal ) );
  }

  crearActualizarLote( regs: ProductoTroncal[] ) {
    const usuario = this.autServicio.obtenerIdUsuarioLogueado();
    regs.forEach( r => r.auditoriaUsuario = usuario );
    return this.httClient.post( this.rutServicio + '/bulk', regs ).pipe( map( res => res as ProductoTroncal[] ) );
  }

}
